import type { SvgComponent } from '@/types/SvgComponent';

export const CanvasIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path d="M4 16H20.5" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 8H20.5" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 4L8 20.5" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 4L16 20.5" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
